export enum Occupancy {
  PrimaryResidence = "PrimaryResidence",
  VacationHome = "SecondaryResidence",
  InvestmentProperty = "Investment"
}

